import type { Linking } from '$lib/types/Components/SharedTypes';
import type { Language } from '$lib/types/Language';

export const getLinkingAriaLabel = (linking: Linking | undefined, language: Language) => {
    if (!linking) {
        return '';
    }

    if (linking.isInternal) {
        return language === 'de' ? 'Zur nächsten Seite' : 'Go to next page';
    }

    if (!linking.isInternal && linking.url) {
        return language === 'de'
            ? `Externer Link zu ${linking.url}`
            : `External link to ${linking.url}`;
    }

    return '';
};
